import { render, staticRenderFns } from "./PrecedentCaseEditor.vue?vue&type=template&id=7f24fe88&scoped=true&"
import script from "./PrecedentCaseEditor.vue?vue&type=script&lang=js&"
export * from "./PrecedentCaseEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrecedentCaseEditor.vue?vue&type=style&index=0&id=7f24fe88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24fe88",
  null
  
)

export default component.exports